import { useState, useEffect, useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";
import { format, getYear, getMonth, addYears } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "./BBDatePicker.css";
import { formatDate } from "./util";

registerLocale("de", de);


export default function PastDatePicker(props) {
  const datePickerRef = useRef(null);


  const closeDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(false); // Закрываем календарь
    }
  };

  const { formData, setFormData, dataName } = props;
  const [selectedDate, setSelectedDate] = useState(formData[dataName]);
  const [isDateSelected, setIsDateSelected] = useState(false); // Состояние для проверки выбрана ли дата

  useEffect(() => {
    const storedValue = sessionStorage.getItem(dataName);
    if (storedValue) {
      setSelectedDate(new Date(storedValue));
      props.onChange(new Date(storedValue)); // Передаем значение даты в родительский компонент
      setIsDateSelected(true); // Устанавливаем флаг выбора даты
    } else {
      setIsDateSelected(false); // Сбрасываем флаг выбора даты
    }
  }, []); // Пустой массив зависимостей

  // useEffect(() => {
  //   const storedValue = sessionStorage.getItem(dataName);
  //   if (storedValue) {
  //     setSelectedDate(new Date(storedValue));
  //     props.onChange(new Date(storedValue)); // Передаем значение даты в родительский компонент
  //   }
  // }, []); // Пустой массив зависимостей


  function updateFormData(date) {
    const newFormData = { ...formData, [dataName]: date };
    setFormData(newFormData);
    sessionStorage.setItem(dataName, date.toISOString());
    setSelectedDate(date);
    props.onChange(date); // Обновляем значение даты в родительском компоненте
    setIsDateSelected(true); // Устанавливаем флаг выбора даты

  }

  const years = Array.from({ length: 50 }, (_, i) => addYears(new Date(), -i));
  const months = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ];

  function click() {
    const element = document.querySelector('.react-datepicker__tab-loop');
    if (element) {
      element.style.display = 'none'; // Скрыть элемент

    } else {
      console.error('Элемент не найден');
    }
  }


  return (

    <DatePicker

      ref={datePickerRef}
      onFocus={e => e.target.blur()}

      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,

      }) => (
        <div>
          <div className="DpClose"><span onClick={closeDatePicker}>x</span>
          </div>
          <div
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}

          >

            {/* <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button> */}
            <select style={{ zIndex: "99" }}
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {years.map((option) => (
                <option key={option} value={getYear(option)}>
                  {getYear(option)}
                </option>
              ))}
            </select>

            <select style={{ zIndex: "99" }}
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            {/* <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button> */}
          </div>
        </div>
      )}
      selected={selectedDate}
      onChange={(date) => {
        date = formatDate(date);
        setSelectedDate(date);
        updateFormData(date);
      }}
      locale="de"
      placeholderText="Datum wählen"
      maxDate={new Date()}
      dateFormat="dd/MM/yyyy"
      withPortal
      shouldCloseOnSelect={false}
    >
      <span >

        <p className="ContainerCalenderBtn">
          
          <button className="CalenderBtn" onClick={closeDatePicker} disabled={!isDateSelected}>Bestätigen</button>

        </p>


      </span>


    </DatePicker>


  );
}






// import { useState, useEffect } from "react";
// import DatePicker, { registerLocale } from "react-datepicker";
// import de from "date-fns/locale/de";
// import "react-datepicker/dist/react-datepicker.css";
// import "./BBDatePicker.css";
// import { formatDate } from "./util";

// registerLocale("de", de);

// export default function PastDatePicker(props) {
//   const { formData, setFormData, dataName } = props;
//   const [selectedDate, setSelectedDate] = useState(formData[dataName]);

//   useEffect(() => {
//     const storedValue = localStorage.getItem(dataName);
//     if (storedValue) {
//       setSelectedDate(new Date(storedValue));
//     }
//   }, [formData, dataName]);

//   function updateFormData(date) {
//     const newFormData = { ...formData, [dataName]: date };
//     setFormData(newFormData);
//     localStorage.setItem(dataName, date.toISOString());
//     props.onChange(date); // Добавляем обновленное значение даты в родительский компонент
//   }

//   return (
//     <DatePicker
//       selected={selectedDate}
//       onChange={(date) => {
//         date = formatDate(date);
//         setSelectedDate(date);
//         updateFormData(date);
//       }}
//       locale="de"
//       placeholderText="Datum wählen"
//       maxDate={new Date()}
//       dateFormat="dd/MM/yyyy"
//     />
//   );
// }